import * as Yup from 'yup';

export default Yup.object().shape({
  date: Yup.string().required('Required'),
  project: Yup.string()
    .min(1)
    .required('Required')
    .trim(),
  cost: Yup.number()
    .min(0.1)
    .required('Required'),
  reason: Yup.string()
    .min(1)
    .required('Required')
    .trim(),
});
